import { PlaygroundSeed } from "../types";

// The from-scratch draft's starting seed: one empty history list,
// presented as items, on a default service.
export const EMPTY_AGENT_SEED: PlaygroundSeed = {
  agent_config: {
    role_config: { core: "", characterization: "" },
    component_configs: [{ type: "limited_list", id: "history" }],
    service_configs: [
      {
        type: "default",
        id: "default",
      },
    ],
    agent_llm: "default",
    presentation_config: {
      presentation_order: [["history", "items"]],
      token_limits: {},
    },
  },
  component_messages: {},
  functions: [],
  cue: null,
  unsupported_components: [],
};
